import {ComputedEdgeLayoutData} from 'processes/graph-builder/flowchart-viz/FlowchartVizConstants';
import {useFlowchartCacheDataContext} from 'processes/graph-builder-processes/flowchart-viz/util/FlowchartCacheDataProvider';
import omitKey from 'util/omitKey';

export type SetDataForEdge = (edgeId: string, data: ComputedEdgeLayoutData) => void;
export type GetDataForEdge = (edgeId: string) => ComputedEdgeLayoutData;
export type DeleteDataForEdge = (edgeId: string) => void;
export type EmptyCache = () => void;

export default function useFlowchartDataCache(): {
  setDataForEdge: SetDataForEdge;
  getDataForEdge: GetDataForEdge;
  deleteDataForEdge: DeleteDataForEdge;
  emptyCache: EmptyCache;
} {
  const edgeCacheRef = useFlowchartCacheDataContext();

  const setDataForEdge: SetDataForEdge = (edgeId, data) => {
    edgeCacheRef.current[edgeId] = data;
  };

  const getDataForEdge: GetDataForEdge = (edgeId) => edgeCacheRef.current[edgeId];

  const deleteDataForEdge: DeleteDataForEdge = (edgeId) => {
    edgeCacheRef.current = omitKey(edgeCacheRef.current, edgeId);
  };

  const emptyCache: EmptyCache = () => {
    edgeCacheRef.current = {};
  };

  return {
    setDataForEdge,
    getDataForEdge,
    deleteDataForEdge,
    emptyCache,
  };
}
